import axios from 'axios'
import Billing from '@/api/billing'

const createPaymentAccount = () => ({
  balance: null,
  blocked: false,
  dailyRate: 0,
  monthlyRate: 0,
  filialsCount: 0,
  daysLeft: null,
  expiringSoon: false,
  expirationWarningDays: null,
  expirationAttentionDays: null,
  validUntil: null,
  runsOutAt: null,
  connectedAt: null,
  promisedPayment: null,
})

const state = ({
  balance: {},
  paymentAccount: createPaymentAccount(),
})

const formatTime = (val) => {
  if (val) {
    let minutes = Math.floor(val / 60)
    let seconds = val % 60
    if (minutes < 10) {
      minutes = `0${minutes}`
    }
    if (seconds < 10) {
      seconds = `0${seconds}`
    }
    return `${minutes}:${seconds}`
  } else {
    return '--:--'
  }
}

const mutations = {
  setFilialMetrics (state, data) {
    state.filialMetrics = data
  },
  clearFilialMetrics (state) {
    state.filialMetrics.map(item => {
      item.value = null
    })
  },
  setPaymentAccount (state, data) {
    state.paymentAccount = { ...state.paymentAccount, ...data }
  },
  resetPaymentAccount (state) {
    state.paymentAccount = createPaymentAccount()
  },
}

const actions = {
  fetchFilialDayMetrics ({ commit, rootGetters, rootState, dispatch }, params) {
    params = params || {
      clear: false,
    }

    if (params.clear) {
      commit('clearFilialMetrics')
    }
    const meta = {}
    meta.filialId = rootGetters['branches/getLocalStorageBranch'].id
    meta.date = rootGetters['orders/getSelectedDate']

    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/fetchDayFilialMetrics']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })

    return axios
      .get(url, {
        params: meta,
        cancelToken: source.token,
      })
      .then(res => {
        commit('setFilialMetrics', res.data.items)
      })
      .catch(err => err)
  },

  setAggregatorsIntegrationStatus ({ state }, data) {
    state.aggregatorsIntegrationStatus = data
  },

  async fetchPaymentAccount ({ state, commit }, { force = false } = {}) {
    if (!force && state.paymentAccount.balance !== null) return
    const data = await Billing.fetchPaymentAccount()
    commit('setPaymentAccount', data)
  },

  // Ответ сливаем целиком: админу филиала бэк дописывает срок и отсрочку для
  // плашки, остальным — только blocked
  async fetchPaymentAccountStatus ({ commit }) {
    const data = await Billing.fetchPaymentAccountStatus()
    commit('setPaymentAccount', data)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
